import moment from "moment";

/**
 * Preenche um numero com zeros ou um caractere a ser escolhido
 * @param {Number} n a ser convertido
 * @param {Number} width numero de zeros a serem adicionados
 * @param {String} z Caractere preenchedor (senao preenchido, será zero)
 */
export const pad = (n, z, width = 2) => {
	let zNew = z || "0";
	let nNew = n + "";
	return nNew.length >= width ? nNew : new Array(width - nNew.length + 1).join(zNew) + nNew;
};

/**
 * Converte segundos em uma string no formato hhmm
 * @param {Number} seconds
 */
export const secondsToHHMM = seconds => {
	let minutes = Math.floor(seconds / 60);
	let hours = Math.floor(minutes / 60);
	minutes = minutes % 60;
	return pad(hours) + ":" + pad(minutes);
};

/**
 * retorna a diferença entre duas datas
 * @param {DateString} startDate data inicial (formato "yyyy-mm-ddThh:mm:ssZ")
 * @param {DateString} finishDate data final (formato "yyyy-mm-ddThh:mm:ssZ")
 * @param {String} quantifier medida de tempo usada para o calculo
 * @returns {String} diferença entre as datas
 */
export const dateDifference = (startDate, finishDate, quantifier = "") => {
	const start = moment(startDate);
	const end = moment(finishDate);
	return end.diff(start, quantifier);
};

/**
 * Extrai as horas de um datestring
 * @param {String} date
 */
export const dateToHHMM = date => {
	if (!date) return;

	// eslint-disable-next-line no-useless-escape
	return date.match(/[0-9]{2}\:[0-9]{2}/) !== null ? date.match(/[0-9]{2}\:[0-9]{2}/)[0] : "";
};

/**
 * Função que retorna as datas Zulu da API em dd/mm/aaaa
 * @param {string} theApiZuluDate
 */

// EX: "2017-10-05T23:30:00Z"
export const getDateFormatted = theApiZuluDate => {
	const day = theApiZuluDate.substr(8, 2);
	const month = theApiZuluDate.substr(5, 2);
	const year = theApiZuluDate.substr(0, 4);

	return day + "/" + month + "/" + year;
};

export const convertHoursToInt = hour =>
	parseInt(hour.match(/[0-9]{2}:[0-9]{2}/)[0].replace(":", ""));
